import { z } from 'zod'

export const adUnitProductsAttributesSchema = z.object({
  prebidStackEnabled: z.boolean(),
  priceGeniusEnabled: z.boolean(),
  refresherEnabled: z.boolean(),
  unfilledRecoveryEnabled: z.boolean(),
  viewabilityToolsEnabled: z.boolean(),
})

export const adUnitTableSchema = z.object({
  adUnitsAttributes: z.record(z.string(), adUnitProductsAttributesSchema),
})

export type AdUnitProductsAttributes = z.infer<typeof adUnitProductsAttributesSchema>
export type AdUnitTableSchema = z.infer<typeof adUnitTableSchema>

export const adUnitTableSchemaDefault: AdUnitTableSchema = {
  adUnitsAttributes: {},
}
